declare global {
  interface Window {
    __ASSETS_DIR__?: string;
  }
}

const DEV_ASSETS_DIR = '';
const PROD_ASSETS_DIR = '/local/templates/dist';

export function getAssetsDir(): string {
  const configuredDir = window.__ASSETS_DIR__?.trim();
  if (configuredDir) {
    return configuredDir.replace(/\/$/, '');
  }

  return process.env.NODE_ENV === 'development' ? DEV_ASSETS_DIR : PROD_ASSETS_DIR;
}

export function getAssetsPath(relativePath: string): string {
  const normalizedPath = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  const assetsDir = getAssetsDir();

  if (!assetsDir) {
    return normalizedPath;
  }

  return `${assetsDir}${normalizedPath}`;
}
